// ==========================================================================
// Extended Locomotive Smooth Scroll
// ==========================================================================
/* jshint esnext: true */
import SmoothScroll from './vendors/SmoothScroll'

/**
 * UNCOMMENT ONLY THE LINES YOU NEED
 */
import { $window, $document, $html } from '../utils/environment';
import Scroll, { DEFAULTS, EVENT } from './Scroll';

import debounce from '../utils/debounce';
import Scrollbar from 'smooth-scrollbar';
// import { isNumeric } from '../utils/is';

export default class extends SmoothScroll {
    constructor(options) {
        super(options)
    }

    /**
     * Initialize scrolling animations
     */
    init() {
        // Add class to the document to know if SmoothScroll is initialized (to manage overflow on containers)
        $html.addClass('has-smooth-scroll');

        this.scrollbar = Scrollbar.init(this.$container[0],{
            syncCallbacks: true
        });

        this.scrollbarStatus = undefined;

        this.setScrollbarLimit();

        this.setWheelDirection(this.isReversed);

        this.addElements();

        this.renderAnimations(true);

        // On scroll
        this.scrollbar.addListener((status) => this.renderAnimations(false, status));

        // Rebuild event
        $document.on(EVENT.REBUILD, () => {
            this.scrollbar.scrollTo(0, 0, 1);
            this.updateElements();
        });

        // Update event
        $document.on(EVENT.UPDATE, (event, options) => this.updateElements(options));

        // Render event
        this.$container.on(EVENT.RENDER, () => this.renderAnimations(false));

        // Scrollto button event
        $document.on(EVENT.CLICK, '.js-scrollto', (event) => {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let offset = $target.data('offset');

            this.scrollTo({
                sourceElem: $target,
                offsetElem: offset,
                speed: 2400
            });
        });

        $document.on(EVENT.SCROLLTO, (event) => this.scrollTo(event.options));

        // Setup done
        $document.triggerHandler({
            type: EVENT.ISREADY
        });

        // Resize event
        $window.on(EVENT.RESIZE, debounce(() => {
            this.updateElements()
        }, 20));
    }

    renderAnimations(isFirstCall, status) {
        if (typeof status === 'object') {
            this.scrollbarStatus = status;
        }

        const scrollbarTop = this.scrollbar.scrollTop;

        if(this.getWay){
            if (scrollbarTop > this.scroll.y) {
                if (this.scroll.direction !== 'down') {
                    this.scroll.direction = 'down';
                }
            } else if (scrollbarTop < this.scroll.y) {
                if (this.scroll.direction !== 'up') {
                    this.scroll.direction = 'up';
                }
            }
        }

        if(this.getSpeed) {
            if (this.scroll.y !== scrollbarTop) {
                this.scroll.speed = this.scrollbar.movement.y;
                this.scroll.y = scrollbarTop;
            }else {
                this.scroll.speed = 0;
            }
        }

        if (this.scroll.y !== scrollbarTop) {
            this.scroll.y = scrollbarTop;
        }

        window.scroll = this.scroll;

        this.callbacks.onScroll(this.scroll)

        this.transformElements(isFirstCall);
        this.animateElements();
    }

    /**
     * Set the scroll bar limit
     */
    setScrollbarLimit() {
        this.scrollbarLimit = this.scrollbar.limit.y + this.windowHeight;

        this.scroll.limit = this.scrollbar.limit.y;
    }
}
